<template>
  <div
    v-show="shareMask"
    @click="close"
    class="wx-share-mask"
    style="display: block; transform-origin: 0px 0px; opacity: 1; transform: scale(1, 1);"
  >请点击右上角的分享</div>
</template>  

<script>
export default {
  props: ["shareMask"],
  data() {
    return {};
  },

  methods: {
    close() {
      this.$emit("closeShareMask", false);
    }
  }
};
</script>
<style lang="less" scoped>
.row .button {
  width: 40%;
  display: inline-block;
  height: 34px;
  margin-left: 5%;
  background: rgba(237, 200, 145, 1);
  border-radius: 17px;
  line-height: 34px;
}
.wx-share-mask {
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  color: #fff;
  display: none;
  padding-top: 97px;
  z-index: 999999;
  text-align: center;
}
.row .button.gxx-close {
  background: #9a9896;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/shareMask.vue